import { render, staticRenderFns } from "./MatchCreator.vue?vue&type=template&id=405751bb&"
import script from "./MatchCreator.vue?vue&type=script&lang=js&"
export * from "./MatchCreator.vue?vue&type=script&lang=js&"
import style0 from "./MatchCreator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports